import { error } from 'app/infrastructure/log';

/**
 * Safely wraps an async/await or promise returning function that might fail
 */
export async function safely(fn: any, ...args: any[]): Promise<any>{
 
  return Promise.resolve()
    .then(!args || !args.length ? fn : () => fn(...args))
    .then(result => result)
    .catch(error);
}
